import { createSlice } from "@reduxjs/toolkit";


const initialState = {
    component: null,
    isVisible: false,
    center: true,
    fullscreen: false,
    otherState: {
        backdrop: undefined,
        sideMenu: false,
        serviceAvailability: false,
        view80: false,
        view60: false,
        view40: false
    }
}

const PopupSlice = createSlice({
    name: 'Popup',
    initialState,
    reducers: {
        update(state, { payload }) {
            state = { ...state, ...payload, 'otherState': { ...state.otherState, ...payload.otherState} }
            return state
        },
        hide(state) {
            state = initialState
            return { ...state }
        },
    }

})


const PopupReducer = PopupSlice.reducer
export const PopupActions = PopupSlice.actions
export default PopupReducer